export const gravityModelTableData = {
  labels: [
    '',
    'placeme.gravitymodeltile.tablelabel_1',
    'placeme.gravitymodeltile.tablelabel_2',
  ],
}
